import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function DisclaimerPage() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-6 pb-12">
        <div className="w-full px-4 md:px-6 lg:px-8 max-w-3xl mx-auto">
          <nav className="text-sm text-stone-500 mb-6">
            <a href="/" className="hover:text-emerald-700 transition-colors">{t('breadcrumb_home')}</a>
            <span className="mx-2">/</span>
            <span className="text-stone-700">Disclaimer</span>
          </nav>

          <h1 className="text-3xl md:text-4xl font-bold text-stone-800 mb-6">Disclaimer</h1>

          <div className="p-5 md:p-6 rounded-xl bg-amber-50 border border-amber-100 mb-8">
            <p className="text-sm md:text-base text-amber-800 leading-relaxed">
              <strong>Important:</strong> This website is an independent resource and does not officially represent CSSBuy. Information about prices, products, sellers, QC, shipping, coupons, and availability may change. Always verify current data before placing any order or payment.
            </p>
          </div>

          <div className="space-y-6">
            <section>
              <h2 className="text-xl font-bold text-stone-800 mb-3">Independent Resource</h2>
              <p className="text-sm md:text-base text-stone-600 leading-relaxed">
                CSSBuyBR.mom is an independent informational website. We are not affiliated with, endorsed by, or officially representing CSSBuy or any related companies. All content on this website is provided for general informational purposes only.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-stone-800 mb-3">No Guarantees</h2>
              <p className="text-sm md:text-base text-stone-600 leading-relaxed">
                We make no representations or warranties of any kind, express or implied, about the completeness, accuracy, reliability, or suitability of the information contained on this website. Any reliance you place on such information is strictly at your own risk.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-stone-800 mb-3">External Links</h2>
              <p className="text-sm md:text-base text-stone-600 leading-relaxed">
                This website contains links to external websites. We have no control over the nature, content, and availability of those sites. The inclusion of any links does not necessarily imply a recommendation or endorsement of the views expressed within them.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-stone-800 mb-3">Product Information</h2>
              <p className="text-sm md:text-base text-stone-600 leading-relaxed">
                Product descriptions, prices, and availability information are provided for reference only and may not be current or accurate. Always verify current product details, prices, and availability directly with the relevant seller or platform before making any purchase.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-stone-800 mb-3">No Liability</h2>
              <p className="text-sm md:text-base text-stone-600 leading-relaxed">
                In no event will we be liable for any loss or damage arising from the use of this website or from any information, products, or services obtained through it. This includes, without limitation, indirect or consequential loss or damage.
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}